module.exports = __webpack_public_path__ + "img/12.9d52ca5b.jpg";